import type { IProcedureGetOne } from '../../interfaces/procedureGetOne';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { Button } from '../common';

interface ITakeProcedureAndStartExaminationButton {
    addExaminationReport?: () => Promise<void>;
    procedure: IProcedureGetOne;
    reloadProcess?: () => Promise<void>;
    request: IRequestGetOne;
}

export function TakeProcedureAndStartExaminationButton(props: ITakeProcedureAndStartExaminationButton) {
    if (
        !props.procedure.authorization ||
        !props.procedure.authorization.canTakeProcess ||
        !props.addExaminationReport ||
        !props.reloadProcess ||
        props.request.recipientPractitionerId
    ) {
        return null;
    }

    return (
        <Button
            color="secondary"
            large
            onClick={async () => {
                const url = `/api/requests/${props.procedure.requestId}/takeProcess`;
                await fetchJson(url, 'POST');
                await props.reloadProcess!();
                await props.addExaminationReport!();
            }}
            outlined
        >
            {translateKey('request.action_addExaminationReport')}
        </Button>
    );
}
